module.exports = __webpack_public_path__ + "img/AI_15.97a09363.png";